import { create } from 'zustand';

export type ToastKind = 'info' | 'ok' | 'err';
export interface Toast {
  id: number;
  text: string;
  kind: ToastKind;
  leaving: boolean;
}

interface ToastStore {
  toasts: Toast[];
  push: (text: string, kind?: ToastKind) => void;
  dismiss: (id: number) => void;
}

let next = 1;
const MAX = 3;

export const useToasts = create<ToastStore>((set, get) => ({
  toasts: [],
  push: (text, kind = 'info') => {
    const id = next++;
    // Same message already visible: don't stack duplicates.
    if (get().toasts.some((t) => t.text === text && !t.leaving)) return;
    set((s) => ({ toasts: [...s.toasts, { id, text, kind, leaving: false }].slice(-MAX) }));
    setTimeout(() => get().dismiss(id), kind === 'err' ? 7000 : 3800);
  },
  dismiss: (id) => {
    if (!get().toasts.some((t) => t.id === id && !t.leaving)) return;
    set((s) => ({ toasts: s.toasts.map((t) => (t.id === id ? { ...t, leaving: true } : t)) }));
    setTimeout(() => set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })), 170);
  },
}));

export const toast = (text: string, kind: ToastKind = 'info') => useToasts.getState().push(text, kind);
